module.exports = __webpack_public_path__ + "media/images/marketing/merzenich-a9ee4429b097d2558407ac87794b622797e74a4a43f9581d1fb8b313e10efdfc.jpg";